import {
    CHANGE_QUOTATION_PRODUCTS,
    UPDATE_ARTICLE_NUMBERS_LIST,
    UPDATE_LIST_OF_PRODUCTS,
    UPDATE_FORM_DETAILS,
    UPDATE_RESPONSE,
    SET_SUBMIT_STATE,
    SET_TERMS_ACCEPT_STATE,
    SET_ERROR_STATE,
    DEFAULT_FORM_DATA,
} from '../Actions/Quotation.action';

import { getData } from '../Services/LocalStorage.service';

const articleNumbersList = getData("products", []);

const defaultState = {
    count: articleNumbersList.length,
    articleNumbersList: articleNumbersList,
    listOfProducts: [],
    formDetails: DEFAULT_FORM_DATA,
    response: {
        mailSent: false,
        message: '',
    },
    errors: {},
    termsAccepted: false,
    submitState: false,
};

export const quotation = (state = defaultState, action) => {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_RESPONSE:
        case SET_SUBMIT_STATE:
        case SET_TERMS_ACCEPT_STATE:
        case SET_ERROR_STATE:
        case CHANGE_QUOTATION_PRODUCTS:
        case UPDATE_LIST_OF_PRODUCTS:
        case UPDATE_FORM_DETAILS:
            return {
                ...state,
                ...payload,
            };
        case UPDATE_ARTICLE_NUMBERS_LIST:
            return {
                ...state,
                ...{
                    count: payload.articleNumbersList.length,
                    articleNumbersList: payload.articleNumbersList,
                },
            };
        default:
            return state;
    }
};